import urls from '@/utils/urls.js';

/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  store.commit('resetStore')
  // Cookies.set('3d_token', null)
  // window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
}

export function accurateCore(num, count) {
  num = num.toString()
  let _arr = num.split('.')

  if (_arr.length < 2) {
    return num * 1
  }
  let more = ''
  if (_arr[1] && _arr[1].length > count) {
    more = _arr[1].slice(count)
    let reg1 = /^5/
    let reg2 = /^4999999/
    if (reg1.test(more) || reg2.test(more)) {
      more = 6
    }
  }
  return (_arr[0] + '.' + _arr[1].slice(0, count) + more) * 1
}

export function retainFiexed(num, count = 2) {
  if (num === null || num === undefined || num === '') {
    return count > 0 ? (0).toFixed(count) : 0
  }
  count = count * 1
  //用来解决134242.955 2位小数不四舍五入的情况
  num = accurateCore(num, count)
  if (count <= 8) {
    num = num.toFixed(8) * 1
  }
  let bai = 1 * 10 ** count
  num = (num * 1).toString()
  let _arr = num.split('.')
  if (_arr[1] && _arr[1].length > count) {
    // num = (num * 1).toFixed(count)
    num = Math.round(num * bai) / bai
  } else {
    num = num * 1
  }
  return count > 0 ? Number(((Number(num) || 0).toFixed(count))) : (num || 0) * 1
}

export function formatWeight(num, count = 2) {
  if (num === null || num === undefined || num === '') {
    return '0'
  }
  num = Number(num)
  if (isNaN(num)) return '0'
  return retainFiexed(num / 1000, count)
}

export function formatAmount(num, count = 2) {
  if (num === null || num === undefined || num === '') {
    return '0'
  }
  num = Number(num);
  if (isNaN(num)) return '0';

  if (Math.abs(num) >= 100000000) {
    return {
      num: retainFiexed(num / 100000000, count),
      unit: '亿'
    }
  } else if (Math.abs(num) >= 10000) {
    return {
      num: retainFiexed(num / 10000, count),
      unit: '万'
    }
  }
  return {
    num: retainFiexed(num, count).toString(),
    unit: '元'
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js